export var EResult = /*#__PURE__*/function (EResult) {
  EResult["Success"] = "success";
  EResult["Error"] = "error";
  EResult["PaymentFailure"] = "failure";
  EResult["Warning"] = "warning";
  return EResult;
}({});